import {animate, state, style, transition, trigger} from '@angular/animations';
import {MediaMatcher} from '@angular/cdk/layout';
import {Component, Input, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {AventiFile} from 'src/app/models/File';
import {FileService} from 'src/app/services/file.service';
import {PopupService} from 'src/app/services/popup.service';
import {environment} from 'src/environments/environment';
import urlExist from 'url-exist';
import {SharedService} from 'src/app/services/shared.service';

@Component({
  animations: [
    trigger('animateDestroy', [
      state('void', style({opacity: '0'})),
      transition('* => void', animate('1000ms ease-in')),
    ]),
  ],
  selector: 'app-thumbnail',
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.css'],
})
export class ThumbnailComponent implements OnInit {
  @Input() file: AventiFile;
  @Input() files: AventiFile[];
  @Input() size = '85px';
  @Input() isLocked = false;
  @Input() disableclick = false;
  @Input() newItem = false;
  downloadurl: string;
  format: string | undefined;
  loaded = false;
  mobileQuery: MediaQueryList;
  warninglevel = -1;
  isimage = true;
  isOnline: boolean;
  class: any;
  private ngUnsubscribe = new Subject();

  // static _file: AventiFile;

  constructor(
    private popupservice: PopupService,
    media: MediaMatcher,
    private fileservice: FileService,
    private sharedservice: SharedService,
  ) {
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
    this.class = ThumbnailComponent;
  }

  async ngOnInit() {
    await this.fileservice.checkAndUpdateIdIfApplicable(this.file);

    this.sharedservice.online.subscribe((online) => {
      this.isOnline = online;
    });

    this.format = this.determineFileFormat(this.file?.type);

    if (this.format === 'image') {
      const downloadUrl = this.getDownloadUrl(this.file);
      if (downloadUrl !== this.downloadurl) {
       this.downloadurl = downloadUrl;
      }
      this.warninglevel = this.getWarningLevel(this.file);
    } else {
      const downloadUrl = this.file?.downloadurl || 'no_image';
      if (downloadUrl !== this.downloadurl) {
        this.downloadurl = downloadUrl;
      }
      this.isimage = false;
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  openDialogImagePreview() {
    if (!this.disableclick && this.isOnline) {
      let fileindex = 0;
      this.files.forEach((f, index) => {
        if (f.id === this.file.id) {
          fileindex = index;
        }
      });
      this.popupservice.openDialogFilePreview(
        this.files,
        fileindex,
        this.isLocked
      );
    }
  }

  async srcChange(thumbnail: { src: string; }) {
    // if (this.warninglevel === -1) {
    // urlExists(this.file.downloadurl200, function (err, exists) {
    //   console.log(exists); // true/false
    //   console.log(err);
    // });
    let newDownloadUrl = this.downloadurl;
    if (newDownloadUrl !== 'no_image') {
      const exist200 = await urlExist(this.file.downloadurl200 || '');
      console.log('200', exist200);
      const exist500 = await urlExist(this.file.downloadurl500 || '');
      console.log('500', exist500);
      const exist = await urlExist(this.file.downloadurl || '');
      console.log('main', exist);
      console.log(thumbnail.src);

      // const ref = this.storage.ref(this.file.storagepath + '/' + this.file.name);
      // // try {
      // ref
      //   .getDownloadURL()
      //   .pipe(take(1))
      //   .subscribe((url) => {
      //     console.log(url);
      //     if (url) {
      // console.log('file exists');
      if (
        exist200 &&
        this.file.downloadurl200 &&
        this.file.downloadurl200.length > 0 &&
        this.file.downloadurl200.includes('firebasestorage')
      ) {
        console.log('200');
        if (thumbnail.src !== this.file.downloadurl200) {
          thumbnail.src = this.file.downloadurl200;
          if (newDownloadUrl !== this.file.downloadurl200) {
            newDownloadUrl = this.file.downloadurl200;
          }
        }
        this.warninglevel = 0;
      } else if (
        exist500 &&
        this.file.downloadurl500 &&
        this.file.downloadurl500.length > 0 &&
        this.file.downloadurl500.includes('firebasestorage')
      ) {
        console.log('500');
        if (thumbnail.src !== this.file.downloadurl500) {
          thumbnail.src = this.file.downloadurl500;
          if (newDownloadUrl !== this.file.downloadurl500) {
            newDownloadUrl = this.file.downloadurl500;
          }
        }
        this.warninglevel = 1;
      } else if (
        exist &&
        this.file.downloadurl &&
        this.file.downloadurl.length > 0 &&
        this.file.downloadurl.includes('firebasestorage')
      ) {
        console.log('main');
        if (thumbnail.src !== this.file.downloadurl) {
          thumbnail.src = this.file.downloadurl;
          if (newDownloadUrl !== this.file.downloadurl) {
            newDownloadUrl = this.file.downloadurl;
          }
        }
        this.warninglevel = 2;
      } else {
        console.log('no_image');
        thumbnail.src = 'no_image';
        if (newDownloadUrl !== 'no_image') {
          newDownloadUrl = 'no_image';
        }
        this.warninglevel = 0;
      }
    } else {
      console.log('no_image');
      thumbnail.src = 'no_image';
      this.isimage = false;
      newDownloadUrl = 'no_image';
      this.warninglevel = 0;
    }
    if (this.downloadurl !== newDownloadUrl) {
      this.downloadurl = newDownloadUrl;
    }
    // Do whatever
    //   } else {
    //     // Doesn't exist... or potentially some other error
    //     if (thumbnail.src !== 'no_image') {
    //       thumbnail.src = 'no_image';
    //     }
    //     this.warninglevel = 0;
    //     console.log('file does not exist');
    //   }
    // });

    // const ref = this.storage.ref(
    //   this.file.storagepath + '/' + this.file.name
    // );
    // ref.getDownloadURL().subscribe((url) => {
    //   console.log(url);
    // });

    // if (false) {
    //   console.log('file exists');
    //   if (
    //     this.file.downloadurl200 &&
    //     this.file.downloadurl200.length > 0 &&
    //     this.file.downloadurl200.includes('firebasestorage')
    //   ) {
    //     thumbnail.src = this.file.downloadurl200;
    //     this.warninglevel = 0;
    //   } else if (
    //     this.file.downloadurl500 &&
    //     this.file.downloadurl500.length > 0 &&
    //     this.file.downloadurl500.includes('firebasestorage')
    //   ) {
    //     thumbnail.src = this.file.downloadurl500;
    //     this.warninglevel = 1;
    //   } else if (
    //     this.file.downloadurl &&
    //     this.file.downloadurl.length > 0 &&
    //     this.file.downloadurl.includes('firebasestorage')
    //   ) {
    //     thumbnail.src = this.file.downloadurl;
    //     this.warninglevel = 2;
    //   } else {
    //     thumbnail.src = 'no_image';
    //   }
    // } else {
    //   // console.log('file does not exist');
    //   thumbnail.src = 'no_image';
    // }
    // }
  }

  private determineFileFormat(type: string | undefined): string {
    if (!type) {
      return 'other';
    }
    if (type.includes('image')) {
      return 'image';
    }
    if (type.includes('video')) {
      return this.mobileQuery.matches ? 'image' : 'video';
    }
    return 'other';
  }

  private getDownloadUrl(file: AventiFile): string {
    if (file.downloadurl200?.length) {
      return file.downloadurl200;
    }
    if (file.downloadurl500?.length) {
      return file.downloadurl500;
    }
    if (file.downloadurl?.length) {
      return file.downloadurl;
    }
    return 'no_image';
  }

  private getWarningLevel(file: AventiFile): number {
    if (file.downloadurl200?.length) {
      return 0;
    }
    if (file.downloadurl500?.length) {
      return 1;
    }
    if (file.downloadurl?.length) {
      return 2;
    }
    return -1;
  }
}
